import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { CurrencyUnit } from "@faire/web-api--source/faire/currency/CurrencyUnit";
import { IGeoConstraint } from "@faire/web-api--source/faire/geo/IGeoConstraint";
import { CountryGroup } from "@faire/web-api--source/indigofair/data/CountryGroup";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
var _obj;
export var CURRENCY_TO_GEO_CONSTRAINT = (_obj = {}, _define_property(_obj, CurrencyUnit.CAD, IGeoConstraint.build({
    country: ISO3166Alpha3.CAN
})), _define_property(_obj, CurrencyUnit.USD, IGeoConstraint.build({
    country: ISO3166Alpha3.USA
})), _define_property(_obj, CurrencyUnit.GBP, IGeoConstraint.build({
    country: ISO3166Alpha3.GBR
})), _define_property(_obj, CurrencyUnit.EUR, IGeoConstraint.build({
    country_group: CountryGroup.EUROPEAN_UNION
})), _define_property(_obj, CurrencyUnit.SEK, IGeoConstraint.build({
    country_group: CountryGroup.EUROPEAN_UNION
})), _define_property(_obj, CurrencyUnit.DKK, IGeoConstraint.build({
    country_group: CountryGroup.EUROPEAN_UNION
})), _define_property(_obj, CurrencyUnit.NOK, IGeoConstraint.build({
    country_group: CountryGroup.EUROPEAN_UNION
})), _define_property(_obj, CurrencyUnit.CHF, IGeoConstraint.build({
    country_group: CountryGroup.EUROPEAN_UNION
})), _define_property(_obj, CurrencyUnit.AUD, IGeoConstraint.build({
    country: ISO3166Alpha3.AUS
})), _obj);
